import { getQuery } from "../util/dom";
import { updateSelection } from "../shop/connect";
var abandonedCart = function abandonedCart() {
  var query = getQuery();
  if (!query.hasOwnProperty('cartId') || query.hasOwnProperty('cartId') && !query.cartId) return;
  updateSelection(query.cartId);
};
export default abandonedCart;


// WEBPACK FOOTER //
// ./scripts/components/abandoned-cart.js